/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { override } from 'flarum/common/extend';
import TagDiscussionModal from 'flarum/tags/forum/components/TagDiscussionModal';

export default function () {
	override(TagDiscussionModal.prototype, 'className', function (this: TagDiscussionModal, original: () => string): string {
		return `${original()} Modal--large`;
	});
}
